import { render, staticRenderFns } from "./ItemAttribut.vue?vue&type=template&id=1be67ba3&scoped=true&"
import script from "./ItemAttribut.vue?vue&type=script&lang=js&"
export * from "./ItemAttribut.vue?vue&type=script&lang=js&"
import style0 from "./ItemAttribut.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ItemAttribut.vue?vue&type=style&index=1&id=1be67ba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be67ba3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardSubtitle,VContainer,VDivider,VFadeTransition})
